// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-ObjectRefTable-ObjectRefTable-module__box--Fnc1g {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.src-components-ObjectRefTable-ObjectRefTable-module__selectBtn--NRNTU {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/ObjectRefTable/ObjectRefTable.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;AACA;EACE,WAAA;AACF","sourcesContent":[".box {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n.selectBtn {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-components-ObjectRefTable-ObjectRefTable-module__box--Fnc1g`,
	"selectBtn": `src-components-ObjectRefTable-ObjectRefTable-module__selectBtn--NRNTU`
};
export default ___CSS_LOADER_EXPORT___;
